import React from 'react'
import {Card, CardBody, CardHeader, CardTitle, Nav, NavItem, NavLink, Row} from "reactstrap";
import {RotateCircleLoading} from "react-loadingg";
import classnames from "classnames";
import {Bar, Doughnut, Line, Pie, Radar} from "react-chartjs-2";
import {chartExample1, chartExample2, chartOptions, parseOptions} from "../../variables/charts";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import Chart from "chart.js";
import businessHelper from "../../helpers/BusinessHelper";
import localeHelpers from "../../helpers/LocaleHelper";

const propTypes = {};
let commonStrings = new LocalizedStrings(common_strings);

class TicketTypeChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ticketData: props.ticketData || null
        };

    }

    componentDidMount() {
        if (window.Chart) {
            parseOptions(Chart, chartOptions());
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.ticketData !== this.state.ticketData) {
            this.setState({ticketData: nextProps.ticketData})
        }
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
    }

    render() {
        this.localize()
        return (
            <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                    {this.state.isLoading &&
                    <RotateCircleLoading color="white"/>
                    }
                    <CardTitle className="text-white">{commonStrings.payment_report} ({businessHelper.currency()})</CardTitle>
                    <Row className="align-items-center">
                        <div className="col">
                            <Nav className="justify-content-end" pills>
                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.props.activeNav === 1
                                        })}
                                        data-toggle="tab"
                                        href="#pablo"
                                        onClick={e => this.props.toggleNavs(e, 1)}
                                    >
                                        <span className="d-none d-md-block">{commonStrings.week}</span>
                                        <span
                                            className="d-md-none">{commonStrings.week.charAt(0)}</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.props.activeNav === 2
                                        })}
                                        href="#pablo"
                                        onClick={e => this.props.toggleNavs(e, 2)
                                        }
                                    >
                                        <span className="d-none d-md-block">{commonStrings.month}</span>
                                        <span
                                            className="d-md-none">{commonStrings.month.charAt(0)}</span>
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.props.activeNav === 3
                                        })}
                                        href="#pablo"
                                        onClick={e => this.props.toggleNavs(e, 3)
                                        }
                                    >
                                        <span className="d-none d-md-block">6 months</span>
                                        <span
                                            className="d-md-none">6</span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                    </Row>
                </CardHeader>
                <CardBody>
                    {/* Chart */}
                    <div className="chart">
                        <Bar
                            data={this.state.ticketData}
                            options={chartExample1.options}
                            getDatasetAtEvent={e => console.log(e)}
                        />
                    </div>
                </CardBody>
            </Card>
        )
    }

}

TicketTypeChart.propTypes = propTypes;

export default TicketTypeChart;